import React, { useState } from 'react';

export default function FAQBlock({ content = {} }) {
  const items = content.items || [];
  const [openIndex, setOpenIndex] = useState(null);

  if (!items.length) return null;

  return (
    <section className="py-8 px-4 sm:px-0">
      <div className="divide-y divide-gray-200 border border-gray-200 rounded-lg overflow-hidden">
        {items.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div key={index}>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                className="w-full flex items-center justify-between gap-4 px-4 sm:px-6 py-4 text-left bg-white hover:bg-gray-50 transition-colors"
                aria-expanded={isOpen}
              >
                <span className="font-medium text-gray-900 text-sm sm:text-base">
                  {item.question}
                </span>
                <span
                  className="shrink-0 text-[#00AAFF] text-xl leading-none transition-transform duration-200"
                  style={{ transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)' }}
                >
                  +
                </span>
              </button>
              <div
                className="overflow-hidden transition-all duration-300 ease-in-out"
                style={{ maxHeight: isOpen ? '500px' : '0px' }}
              >
                <div className="px-4 sm:px-6 pb-4 text-gray-600 text-sm leading-relaxed">
                  {item.answer}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
